import React from 'react';
import Header from '../components/Header/Header';

import avatar from '../assets/image/about/ava.png';
import LedAnima from '../components/UI/LedAnima';
import SheduleAnima from '../components/UI/ScheduleAnima';
import { useTranslation } from 'react-i18next';

const AboutPage = () => {
  const { t } = useTranslation();
  return (
    <div className="page-about" activePage="/">
      <Header />
      <div className="page-about__container container">
        <div className="pg-about-top">
          <div className="pg-about-top__des about-des">
            <h2 className="page-about__title  main-title">
              {t('about_us_title')}
            </h2>
            <p className="page-about__text">{t('about_us_text')}</p>
          </div>
          <div className="pg-about-top__img">
            <img src={avatar} alt="" />
          </div>
        </div>
        <div className="pg-about-mid">
          <div className="pg-about-mid__des about-des">
            <h2 className="page-about__title  main-title about__title--blue">
              {t('generating_new_ideas_title')}
            </h2>
            <p className="page-about__text">{t('generating_new_ideas_text')}</p>
          </div>
          <div className="pg-about-mid__img">
            <LedAnima />
          </div>
        </div>
        <div className="pg-about-bottom">
          <div className="pg-about-bottom__img">
            <SheduleAnima />
          </div>
          <div className="pg-about-bottom__des about-des">
            <h2 className="page-about__title  main-title">
              {t('our_mission_title')}
            </h2>
            <p className="page-about__text">{t('our_mission_text')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
